import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cbcc8b8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=cbcc8b8c&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=cbcc8b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcc8b8c",
  null
  
)

export default component.exports